<template>
  <div>
    <component v-if="active" :is="`password-guard-${guardType}`"
               :saving="saving"
               ref="guard"
               @unlock="checkPassword($event)"/>
    <template v-else>
      <div class="text-text-secondary text-sm font-medium flex items-center leading-relaxed h-16">
        <IconLockOpen class="text-green mr-6"/>
        {{ $t('unlockedText') }}
      </div>
    </template>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {required} from "vuelidate/lib/validators";
import IconLockOpen from "@/components/icons/IconLockOpen";
import PasswordGuardPASS from "@/components/common/PasswordGuard/PasswordGuardPASS";
import PasswordGuardPIN from "@/components/common/PasswordGuard/PasswordGuardPIN";

export default {
  name: "PasswordGuard",
  components: {
    PasswordGuardPASS,
    PasswordGuardPIN,
    IconLockOpen,
  },
  data() {
    return {
      saving: false
    }
  },
  validations: {
    password: {
      required,
    },
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapState('cabinet/passwordGuard', ['active']),
    guardType() {
      return !!this.user_info.data.pin_enabled ? 'PIN' : 'PASS'
    }
  },
  methods: {
    ...mapActions('cabinet/passwordGuard', ['unlockSettings']),
    ...mapMutations('cabinet/passwordGuard', ['destroyGuard']),
    ...mapMutations('auth', ['logout']),
    checkPassword(payload) {
      this.saving = true;

      this.unlockSettings(payload).then(res => {
        if (res.body.success) {
          this.$emit('success')
          this.saving = false;
          this.destroyGuard();
        } else {
          this.saving = false;
          this.$refs.guard.showTip = true;
          if (!!payload.pin) this.$toasted.error(this.$t('PINError'))
          if (!!payload.password) this.$toasted.error(this.$t('PasswordError'))
        }
      })
    }
  },
  i18n: {
    messages: {
      en: {
        lockedText: 'To apply changes enter your password',
        unlockedText: 'You have passed verification',
        passwordLabel: 'Enter password',
        PINError: 'You entered incorrect PIN.<br>We sent a PIN in a welcome email after registering with MoneyKeeper. <br> If it\'s gone for a long time, we can send a new one.',
        PasswordError: 'You entered incorrect password.<br>To restore your password, logout from cabinet <br> and then restore it as usual in "Forgot password" form.'
      },
      ru: {
        lockedText: 'Чтобы изменить настройки нужно указать ваш пароль',
        unlockedText: 'Вы прошли верификацию',
        passwordLabel: 'Введите пароль',
        PINError: 'Вы ввели некорректный PIN.<br>Мы отправляли его в приветственном e-mail. Если вы потеряли или забыли его - мы легко отправим вам новый.',
        PasswordError: 'Вы ввели некорректный пароль.<br> Если вы забыли пароль, вам нужно будет выйти из кабинета <br> и восстановить пароль через почту, как обычно.'
      }
    }
  }
}
</script>